module.exports = __webpack_public_path__ + "img/syukyaku-top-ira005.3dd58ea4.png";